var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83326 19.3341C8.50271 19.3341 8.22563 19.2223 8.00201 18.9987C7.7784 18.7751 7.6666 18.498 7.6666 18.1675V11.1675L0.899931 2.53415C0.608264 2.14526 0.564514 1.73692 0.768681 1.30915C0.972848 0.881369 1.32771 0.66748 1.83326 0.66748H18.1666C18.6722 0.66748 19.027 0.881369 19.2312 1.30915C19.4353 1.73692 19.3916 2.14526 19.0999 2.53415L12.3333 11.1675V18.1675C12.3333 18.498 12.2215 18.7751 11.9978 18.9987C11.7742 19.2223 11.4972 19.3341 11.1666 19.3341H8.83326ZM9.99993 10.3508L15.7749 3.00081H4.22493L9.99993 10.3508Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAlt);
export default __webpack_public_path__ + "static/media/icon_filter_alt.44e4830fde241bd7eab993119c2f5dcd.svg";
export { ForwardRef as ReactComponent };